import { render, staticRenderFns } from "./二次开发.vue?vue&type=template&id=209a5c01&scoped=true&"
import script from "./二次开发.vue?vue&type=script&lang=js&"
export * from "./二次开发.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209a5c01",
  null
  
)

export default component.exports